/**
 * Group UniversalChat / MetaWhatsApp message reactions for ConversationView chips.
 * Mirrors VueStandaloneAgent HistoryItemUniversalChat reactionChips.
 */

function normalizeReactionEntry(entry) {
    if (!entry || typeof entry !== 'object') {
        return { Emoji: '', From: '', ReactionId: '' };
    }
    const emoji = entry.Emoji ?? entry.emoji ?? '';
    const from = entry.From ?? entry.from ?? '';
    const reactionId = entry.ReactionId ?? entry.reactionId ?? entry.reaction_id ?? '';
    return {
        Emoji: emoji == null ? '' : String(emoji),
        From: from == null ? '' : String(from),
        ReactionId: reactionId == null ? '' : String(reactionId),
    };
}

export function getMessageReactions(message) {
    const raw =
        message?.content?.Message?.Reactions ||
        message?.content?.Message?.reactions ||
        message?.Reactions ||
        message?.reactions ||
        [];
    if (!Array.isArray(raw)) return [];
    return raw.map((entry) => normalizeReactionEntry(entry)).filter((entry) => entry.Emoji);
}

/** @returns {{ key: string, emoji: string, count: number, title: string }[]} */
export function getReactionChips(message) {
    const grouped = {};
    getMessageReactions(message).forEach((reaction) => {
        const emoji = reaction.Emoji;
        if (!grouped[emoji]) {
            grouped[emoji] = {
                key: emoji,
                emoji,
                count: 0,
                froms: [],
            };
        }
        grouped[emoji].count += 1;
        if (reaction.From) grouped[emoji].froms.push(reaction.From);
    });
    return Object.values(grouped).map((chip) => ({
        key: chip.key,
        emoji: chip.emoji,
        count: chip.count,
        title: chip.froms.filter(Boolean).join(', ') || chip.emoji,
    }));
}
